import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const mediaObjectDefaultVariants = {
  "isReversed": false,
  "isStacked": false
}
const mediaObjectCompoundVariants = [
  {
    "isReversed": true,
    "isStacked": true,
    "css": {
      "root": {
        "gridTemplateColumns": "1fr",
        "gridTemplateAreas": "\"body\"\n \"image\""
      }
    }
  }
]

const mediaObjectSlotNames = [
  [
    "root",
    "MediaObject__root"
  ],
  [
    "image",
    "MediaObject__image"
  ],
  [
    "body",
    "MediaObject__body"
  ],
  [
    "right",
    "MediaObject__right"
  ]
]
const mediaObjectSlotFns = /* @__PURE__ */ mediaObjectSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, mediaObjectDefaultVariants, getSlotCompoundVariant(mediaObjectCompoundVariants, slotName))])

const mediaObjectFn = memo((props = {}) => {
  return Object.fromEntries(mediaObjectSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const mediaObjectVariantKeys = [
  "isReversed",
  "isStacked"
]
const getVariantProps = (variants) => ({ ...mediaObjectDefaultVariants, ...compact(variants) })

export const mediaObject = /* @__PURE__ */ Object.assign(mediaObjectFn, {
  __recipe__: false,
  __name__: 'mediaObject',
  raw: (props) => props,
  variantKeys: mediaObjectVariantKeys,
  variantMap: {
  "isReversed": [
    "true"
  ],
  "isStacked": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, mediaObjectVariantKeys)
  },
  getVariantProps
})